import loadable from '@loadable/component';
import React from 'react';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import { timeout } from '../../lazy/lazyConstants';

export default loadable(
    () => import(/* webpackChunkName: "SignInSliderConnect" */ './SignInSliderConnect'),
    {
        fallback: (
            <div className="loading-wrapper">
                <Loader keepOverlay loaderClass="lazy-loader" />
            </div>
        ),
        timeout,
        onError: (...args) => {
            console.error('SIGNIN SLIDER ERROR STACK:', args);
            return window.location.assign('/signin');
        },
    }
);
